import { Methods } from '../../api/methods.js';
import type { ParsedArgs } from '../args.js';
import { flag } from '../args.js';
import { CliError, ExitCode } from '../errors.js';
import type { CommandResult } from '../output.js';
import { readSecret } from '../secret.js';
import { downloadLogs, request, requireConfirmation } from './common.js';

export async function adminCommand(args: ParsedArgs): Promise<CommandResult> {
  const action = args.positionals[1] ?? 'health';
  switch (action) {
    case 'health':
      return request(args, Methods.Health);
    case 'update-check':
      return request(args, Methods.UpdateCheck);
    case 'update-apply':
      requireConfirmation(args, 'Applying a Core update requires confirmation');
      return request(args, Methods.UpdateApply);
    case 'logs-download':
      return downloadLogs(args, 'admin logs-download requires --output <path>');
    case 'auth-claim': {
      const claimUrl = flag(args.flags, 'claim-url');
      const providedToken = flag(args.flags, 'token');
      if (!claimUrl) {
        throw new CliError('admin auth-claim requires --claim-url', ExitCode.Usage);
      }
      if (providedToken !== undefined && providedToken !== '-') {
        throw new CliError(
          '--token accepts only -; provide claim token through prompt or stdin',
          ExitCode.Usage,
        );
      }
      const token = await readSecret('Core claim token: ');
      if (!token) throw new CliError('admin auth-claim requires a token', ExitCode.Usage);
      return request(args, Methods.SettingsAuthClaim, { claimUrl, token });
    }
    case 'playtime':
      return request(args, Methods.Playtime);
    case 'playtime-limits':
      return request(args, Methods.PlaytimeLimits);
    default:
      throw new CliError(`Unknown admin action "${action}"`, ExitCode.Usage);
  }
}
